import Tax from '../../../../icons/tax.svg?react';
import Premium from '../../../../icons/premium.svg?react';
import MoneyBack from '../../../../icons/moneyback.svg?react';
import RoboChat from '../../../../icons/RoboChat.svg?react';
import receiveCall from '../../../../icons/receiveCall.svg?react';
import Review from '../../../../icons/review.svg?react';
import submitApplication from '../../../../icons/submitApplication.svg?react';
import shieldProtected3 from '../../../../icons/shieldProtected3.svg?react';

export const BestFeatures = [
  {
    text: "No premiums due until your policy is approved",
    icon: Premium,
  },
  {
    text: "10 to 30 day money back guarantee (or according to your state regulations)",
    icon: MoneyBack,
  },
  {
    text: "You can cancel your policy anytime",
    icon: Premium,
  },
  {
    text: "Life insurance proceeds are typically tax free at distribution",
    icon: Tax,
  },
  {
    text: "Change your beneficiary at any time",
    icon: Tax,
  },
];

export const EasySteps = [
  {
    text: "Expect a call from “Covr” with a 208 area code",
    icon: receiveCall,
  },
  {
    text: "Speak with your licensed expert to review your best options",
    icon: Review,
  },
  {
    text: "Choose your solution and let us handle the application",
    subText: ["No payment is due until you review and approve your policy"],
    icon: submitApplication,
  },
  {
    text: "Once approved, sign and pay initial premium to activate your coverage",
    icon: shieldProtected3,
  },
];

export const InsurancePlan = [
  {
    title: "Want coverage for another person?",
    content: "Getting your spouse insured can be just as important as your own insurance.",
    icon: RoboChat,
    btnTitle: 'GET A QUOTE',
    linkTo: '/landing/term-insurance',
  },
  {
    title: "Other Insurance Options",
    content: "Explore coverage options in a variety of categories, all from your mobile device.",
    icon: RoboChat,
    btnTitle: 'SEE PRODUCTS',
    linkTo: '/',
  },
  {
    title: "Policy Review",
    content: "Save money on your existing insurance policies with a free no obligation policy review.",
    icon: RoboChat,
    btnTitle: 'GET A POLICY REVIEW',
    linkTo: '/policy-review',
  },
];

export const MIN_MAX_RANGES = {
  minHeightInches: 35,
  maxHeightInches: 85,
  minWeight: 77,
  maxWeight: 396,
  minSliderHeightInches: 0,
  maxSliderHeightInches: 108,
  minSliderWeight: 0,
  maxSliderWeight: 600,
};

export const GENDER_OPTIONS = [
  { label: "Female", value: "F" },
  { label: "Male", value: "M" },
];

export const TOBACCO_OPTIONS = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

export const COVR_DISCLAIMER =
  'Insurance products are sold through Covr Financial Technologies Inc ("Covr"). Covr sells insurance as an agent or broker by contractual agreements with its insurance carrier providers. Covr is licensed in the following states: Delaware (3000067942), Idaho (607086), California (0L77229).';
